import { history } from "../_helpers";

export const sourcesDestinationsServices = {
  getSourceDestinationsByConnectionId,
  editSourceDestinationById,
  deleteSourceDestinationById,
};

function getSourceDestinationsByConnectionId(connectionId) {
  let user = JSON.parse(localStorage.getItem("user"));
  const requestOptions = {
    method: "GET",
    headers: {
      "x-access-token": user.accessToken,
    },
  };
  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/connection/${connectionId}/source/destination`,
    requestOptions
  ).then(handleResponse);
}

function editSourceDestinationById(infraConfigId, formData) {
  let user = JSON.parse(localStorage.getItem("user"));
  const requestOptions = {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      "x-access-token": user.accessToken,
    },
    body: JSON.stringify(formData),
  };
  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/source/destination/${infraConfigId}`,
    requestOptions
  ).then(handleResponse);
}

function deleteSourceDestinationById(formData, infraConfigId) {
  let user = JSON.parse(localStorage.getItem("user"));
  const requestOptions = {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      "x-access-token": user.accessToken,
    },
    body: JSON.stringify(formData),
  };
  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/source/destination/${infraConfigId}`,
    requestOptions
  ).then(handleResponse);
}

function handleResponse(response) {
  return response.text().then((text) => {
    const data = text && JSON.parse(text);
    if (!response.ok) {
      // checking token expiry
      if (
        response.status === 401 &&
        data.message.includes("Invalid JWT token")
      ) {
        // redirecting to signin page
        history.push("/auth/signin");
        // removing local storage token
        localStorage.removeItem("user");
        return;
      }
      const error = (data && data.message) || response.statusText;
      return Promise.reject(error);
    }
    return data;
  });
}
